$(document).on('change','.collection-qty-box',function(){
    var get_val = $(this).val();
    var get_id = $(this).data('id');
    var create_function = 'Shopify.addItem('+get_id+', '+get_val+'); return false;';
    $(this).parents('.custom-button-add-to-cart-wraper').find('a').attr('onclick',create_function);
    console.log(create_function);
});
  $('.js-anchor-link').click(function(e){
              e.preventDefault();
            let heightHeader = $("#shopify-section-header_special").outerHeight();
              var target = $($(this).attr('href'));
              console.log(target);
              if(target.length){
                console.log(heightHeader);
                var scrollTo = target.offset().top - heightHeader;
                $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
              }
            });
$('.accordion_head').click(function(){
  $(this).toggleClass('minus_extra_class');
  if($(this).hasClass('minus_extra_class')){
   $(this).find('.plusminus').html('-');   
  }else{
    $(this).find('.plusminus').html('+');  
  }
  $(this).parents('.MegamenuMobileSubmenu-item').find('.accordion_body').slideToggle();
});

// filter popup js
$(document).on('click', '.filters_wrapper', function(e) {
$(".inner__container").removeClass('is-selected');
$(this).parent().closest('.inner__container').addClass('is-selected');
});

// hide filter popup outside click
$(document).on('click', function (event) {
if (!$(event.target).closest('.inner__container.is-selected').length) {
// ... clicked on the 'body', but not inside of #menutop
$(".inner__container").removeClass('is-selected');
}
});

// filter close button js
$(document).on('click', '.filters_cross', function(e) {
  $(".inner__container").removeClass('is-selected');
  $(this).parent('.inner__container').removeClass('is-selected');

});


$(document).on('click', '.filters_wrapper_ul li.filter_name_li', function(e) {
e.preventDefault();
$("li.sort_options_custom").removeClass('active');
var classexist  = $(this).hasClass("active");

console.log('clicked');
if(classexist == true){
$(this).removeClass('active');
$(this).parent().closest('.inner__container').removeClass('Counter');

$(this).fadeOut("slow", function() {

$(this).parents('.inner__container').removeClass('is-selected');
});
$(this).fadeIn(); 

$("span.clear_all_text").hide();
}
if(classexist == false){


$(this).parent().closest('.inner__container').addClass('Counter');

$(this).parents('.inner__container').find('li.filter_name_li').removeClass('active');
$(this).addClass('active');	
$(this).fadeOut("slow", function() {

$(this).parents('.inner__container').removeClass('is-selected');

});-
$(this).fadeIn(); 
}
var all_actives= $('li.filter_name_li.active').length;
if(all_actives == 1 ){
var all_data_name = '';
var cross_button = $(".cross_button_for_filters").html();
var get_name= $("li.filter_name_li.active input.tag_name_hidden").attr('data-name');

var get_tag= $("li.filter_name_li.active input.tag_name_hidden").val();
console.log('get_tag=='+get_tag);
var get_col= $("#get_current_url").attr('data-col-url');
var url= get_col+"/"+get_tag;
console.log('get_col=='+get_col);
console.log('url=='+url);
all_data_name += '<div class="cross_btn_wrapper" >'+get_name + '<span class="individual_cross" data-tag="'+get_tag+'">' +cross_button + '</span>' + '</div>';
var get_name= all_data_name.slice(0,-1);
console.log('all_data_name=='+all_data_name);
console.log('get_name=='+get_name);
console.log('===================================================================================================================================');


}else{
var contains = '';
var all_data_name = '';
$("li.filter_name_li.active input.tag_name_hidden").each(function(){
var get_name= $(this).attr('data-name');
var get_all_tag= $(this).val();
console.log(get_all_tag);
var cross_button = $(".cross_button_for_filters").html();
all_data_name += '<div class="cross_btn_wrapper" >'+get_name + '<span class="individual_cross" data-tag="'+get_all_tag+'">' +cross_button + '</span>' + '</div>';


contains +=get_all_tag+'+';

});
var get_name= all_data_name.slice(0,-1);
var final_contains= contains.slice(0,-1);
var get_col= $("#get_current_url").attr('data-col-url');
var url= get_col+"/"+final_contains;

console.log("get_name==="+get_name);
console.log("final_contains==="+final_contains);
console.log("get_col==="+get_col);
console.log("url==="+url);
}
$("span.clear_all_text").show();

$("#get_current_url").val(url);
var all_actives= $('li.filter_name_li.active').length;
if(all_actives > 0 ){
$(".clear_all_text").addClass('active');

}
else{
$(".clear_all_text").removeClass('active');

}
console.log(url);
$.ajax({
url: url,
type: "GET",
dataType: "html",
success: function(data) {

if(all_actives > 0 ){
$(".clear_all_text").html('Filter by: ');
}else{
$(".clear_all_text").html('');

}
console.log(url);
var found = $(data).find("div").hasClass("Collection-notFound");
$('.shop-page-content').html($(data).find('.shop-page-content').html());
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
setTimeout(function(){
var getcount = $('.prod-count').length;
if(getcount== 0){
var get_eroor=  '<div class="Collection-notFound">No products found. Please take a look at <a href="/collections/all">our other products</a></div>';
$('.shop-page-content').html(get_eroor);
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
}
},1200);
 },
});  

});




// Selected filters cross button
$(document).on('click', '.individual_cross', function(e) {


var remove_url= $(this).attr('data-tag');
var data_val= $("#get_current_url").val();
console.log(data_val);
console.log(remove_url);
$(this).parent().addClass('hide');



$("li.filter_name_li.active").each(function(){


var equal= $(this).find('.tag_name_hidden').val();
if(equal == remove_url){
console.log('1'+equal);
console.log('2'+remove_url);
$(this).parent('.inner__container').removeClass('Counter');

$(this).removeClass('active');
}
});
if(data_val.indexOf(remove_url) != -1){
data_val= data_val.replace(remove_url, ""); 
}
var plus_yes= data_val.slice(-1);
if(plus_yes== '+'){
data_val = data_val.slice(0, -1) + '';
$("#get_current_url").val(data_val);

}else{
$("#get_current_url").val(data_val);

}
var data_val2= $("#get_current_url").val();

$.ajax({
url: data_val2,
type: "GET",
dataType: "html",
success: function(data) {
$('.shop-page-content').html($(data).find('.shop-page-content').html());
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
setTimeout(function(){
var getcount = $('.prod-count').length;
if(getcount== 0){
var get_eroor=  '<div class="Collection-notFound">No products found. Please take a look at <a href="/collections/all">our other products</a></div>';
$('.shop-page-content').html(get_eroor);
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
}
},1200);
},
});  
var chkClass= $('.cst_'+remove_url);
if(chkClass.hasClass('active')){

}else{
chkClass.parents('.inner__container').removeClass('Counter');
console.log('hello1');
}
var a= $(".cross_btn_wrapper.hide").length;
var b= $(".cross_btn_wrapper").length;
if(a==b){
$("span.clear_all_text").hide();
}
else{
$("span.clear_all_text").show();

}

});



//  Filters Sort button js 

$(document).on('click', '.sort_options_custom', function(e) {
e.preventDefault();
$(".sort_options_custom").removeClass('active');

var classexist  = $("li.filter_name_li").hasClass("active");
if(classexist == true){
$("span.clear_all_text").show();
}
else{
$("span.clear_all_text").hide();
}
var classexist2  = $("li.sort_options_custom").hasClass("active");
if(classexist2 == true){
$(this).removeClass('active');
}
else{
$(this).addClass('active');
}



var all_actives= $('li.filter_name_li.active').length;
if(all_actives == 1 ){
var get_tag= $("li.filter_name_li.active input.tag_name_hidden").val();
var get_col= $("#get_current_url").attr('data-col-url');

var url= get_col+"/"+get_tag;
}else{
var contains = '';
$("li.filter_name_li.active input.tag_name_hidden").each(function(){
var get_all_tag= $(this).val();
contains +=get_all_tag+'+';

});
var final_contains= contains.slice(0,-1);
var get_col= $("#get_current_url").attr('data-col-url');

var url= get_col+"/"+final_contains;
}
var selected_val= $(this).parent('ul.filters_wrapper_ul').find('.sort_options_custom.active .tag_name_hidden').val();
var data=url+"?sort_by="+selected_val;
$(".inner__container.is-selected").removeClass('is-selected');

$.ajax({
url: data,
type: "GET",
dataType: "html",
success: function(data) {
$('.shop-page-content').html($(data).find('.shop-page-content').html());
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
setTimeout(function(){
var getcount = $('.prod-count').length;
if(getcount== 0){
var get_eroor=  '<div class="Collection-notFound">No products found. Please take a look at <a href="/collections/all">our other products</a></div>';
$('.shop-page-content').html(get_eroor);
$(".selected_filters").removeClass('hide');
$(".selected_filters span.filters_names").html(get_name);
}
},1200);
},
});

});
$(document).on('click','.custom-header-search-wraper a#search-icon-new',function(){
    $('.SearchField.js-offcanvas').addClass('is-expanded');
  $('.SearchField.js-offcanvas .input__search').focus();
}); 
$(document).on('click','.custom-header-search-wraper .SearchField-btn.SearchField-clear',function(){
    $('.SearchField.js-offcanvas').removeClass('is-expanded');
$('.custom-header-search-wraper .input__search').val('');
});
  $('.mobile-accordian-wraper h5').on('click', function() {
    $(this).parents('.mobile-accordian-wraper').toggleClass('active');
  });
    $(document).ready(function(){
    var opencart = localStorage.getItem('open-cart');
    if(opencart == 'yes'){
      localStorage.removeItem("open-cart");
      $('#offcanvas-cart-icon-2').trigger('click');
    }
  });